module.exports = __webpack_public_path__ + "a4bf36516252f325691d3253ff5c49ea.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/latte.png
// module id = 2853
// module chunks = 0